module.exports = __webpack_public_path__ + "media/images/iconbox/icon9-57efd9050d3e7f648515168dcee97e11.png";